module.exports = __webpack_public_path__ + "static/media/google-firebase-home.c3630ba8.png";